import { toast } from "react-toastify"
const _ = require('lodash');

export const objToQueryString = (obj) => {
   var str = [];
   for (var p in obj)
      if (obj.hasOwnProperty(p)) {
         str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
   return str.join("&");
}

export const removeVietnameseTones = (str) => {
   str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
   str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
   str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
   str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
   str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
   str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
   str = str.replace(/đ/g, "d");
   str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
   str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
   str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
   str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
   str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
   str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
   str = str.replace(/Đ/g, "D");
   // Some system encode vietnamese combining accent as individual utf-8 characters
   // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
   str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
   str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
   // Remove extra spaces
   // Bỏ các khoảng trắng liền nhau
   str = str.replace(/ + /g, " ");
   str = str.trim();
   // Remove punctuations
   // Bỏ dấu câu, kí tự đặc biệt
   str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
   return str;
}

export const regexUrlMatch = (array, url) => {
   const stringToMatch = url;
   const patterns = array;
   const regexPatterns = patterns.map(pattern => new RegExp("^" + pattern.replace(/:[^/]+/g, '[^/]+') + "$"));
   return regexPatterns.some(regex => regex.test(stringToMatch));
}

export const addZeros = (number) => {
   if (number < 10) {
      return `0${number}`;
   }
   return number
}

export const formatTime = (timestamp) => {
   if (timestamp) {
      const dateTime = new Date(timestamp);
      const day = dateTime.getDate()
      const month = dateTime.getMonth() + 1;
      const year = dateTime.getFullYear();
      let hours = dateTime.getHours();
      const minutes = dateTime.getMinutes();
      const amPm = hours >= 12 ? 'CH' : 'SA';
      hours = hours % 12;
      hours = hours ? hours : 12;
      return `${addZeros(day)}/${addZeros(month)}/${year} ${addZeros(hours)}:${addZeros(minutes)} ${amPm}`;
   }
   return "----";
}

export const formatTimeTxt = (timestamp) => {
   const dateTime = new Date(timestamp);
   const day = dateTime.getDate()
   const month = dateTime.getMonth() + 1;
   const year = dateTime.getFullYear();
   let hours = dateTime.getHours();
   const minutes = dateTime.getMinutes();
   const amPm = hours >= 12 ? 'CH' : 'SA';
   hours = hours % 12;
   hours = hours ? hours : 12;

   const currentTime = new Date();
   const currentDay = currentTime.getDate();
   if (currentDay == day) {
      return `Hôm nay lúc ${addZeros(hours)}:${addZeros(minutes)} ${amPm}`;
   } else if (currentDay - day == 1) {
      return `Hôm qua lúc ${addZeros(hours)}:${addZeros(minutes)} ${amPm}`;
   }
   return `${addZeros(day)}/${addZeros(month)}/${year} ${addZeros(hours)}:${addZeros(minutes)} ${amPm}`;
}
//hàm lấy thời gian giờ:phút
export const formatTimeHM = (timestamp = new Date().getTime()) => {
   const dateTime = new Date(timestamp);
   const hours = dateTime.getHours();
   const minutes = dateTime.getMinutes();
   return `${addZeros(hours)}:${addZeros(minutes)}`;
}

export const formatTimeHMDMY = (timestamp = new Date().getTime()) => {
   const dateTime = new Date(timestamp);
   const day = dateTime.getDate()
   const month = dateTime.getMonth() + 1;
   const year = dateTime.getFullYear();
   let hours = dateTime.getHours();
   const minutes = dateTime.getMinutes();
   return `${addZeros(hours)}:${addZeros(minutes)} ${addZeros(day)}/${addZeros(month)}/${year}`;
}

export const formatTimeDMY = (timestamp = new Date().getTime()) => {
   const dateTime = new Date(timestamp);
   const day = dateTime.getDate()
   const month = dateTime.getMonth() + 1;
   const year = dateTime.getFullYear();
   return `${addZeros(day)}/${addZeros(month)}/${year}`;
}

export const randomCampaignName = () => {
   return `Campaign ${formatTime(new Date().getTime())}`;
}

export const formatPrice = (number) => {
   return number != undefined ? _.replace(number.toString(), /\B(?=(\d{3})+(?!\d))/g, ",") : '';
}

export const showSuccessToasts = (message) => {
   toast.dismiss();
   toast.success(
      <div className="wrap-notification-container">
         <div className="notification-container">
            <span>
               <div className="notification notification-success">
                  <div className="notification-message" role="alert">
                     <div className="message">{message}</div>
                  </div>
               </div>
            </span>
         </div>
      </div>
   )
}

export const showErrorToasts = (message) => {
   toast.dismiss();
   toast.error(
      <div className="wrap-notification-container">
         <div className="notification-container">
            <span>
               <div className="notification notification-error">
                  <div className="notification-message" role="alert">
                     <div className="message">{message}</div>
                  </div>
               </div>
            </span>
         </div>
      </div>
   )
}

export const showErrorToastsV2 = (message) => {
   toast.dismiss();
   toast.error(
      <span>
         <div className="app-notification-notice app-notification-notice-closable">
            <div className="app-notification-notice-content">
               <div className="app-notification-notice-with-icon">
                  <span className="app-notification-notice-icon app-notification-notice-icon-error">
                     <svg className="app-svg-inline-block" width="16px" height="16px" viewBox="0 0 16 16">
                        <g><path d="M8,0C3.581,0,0,3.582,0,8s3.581,8,8,8s8-3.582,8-8S12.419,0,8,0z M11.707,10.293 c0.391,0.391,0.391,1.023,0,1.414C11.512,11.902,11.256,12,11,12s-0.512-0.098-0.707-0.293L8,9.414l-2.293,2.293   C5.512,11.902,5.256,12,5,12s-0.512-0.098-0.707-0.293c-0.391-0.391-0.391-1.023,0-1.414L6.586,8L4.293,5.707   c-0.391-0.391-0.391-1.023,0-1.414s1.023-0.391,1.414,0L8,6.586l2.293-2.293c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414   L9.414,8L11.707,10.293z"></path></g>
                     </svg>
                  </span>
                  <div className="app-notification-notice-message">
                     <span className="app-notification-notice-message-single-line-auto-margin"></span>
                     {message}
                  </div>
               </div>
            </div>
            <a tabindex="0" className="app-notification-notice-close" onClick={() => toast.dismiss()}>
               <svg className="app-svg-inline-block" width="16px" height="16px" viewBox="0 0 24 24"> <g><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"></path></g></svg>
            </a>
         </div>
      </span>
   )
}

export const showWarningToasts = (message) => {
   toast.dismiss();
   toast.warning(
      <div style={{ display: 'flex' }}>
         <div style={{ marginLeft: '10px', display: 'flex', alignItems: 'center' }}>
            <div dangerouslySetInnerHTML={{
               __html: `<div className="icon"><i className="material-icons" style="color: #fbc02d;">warning</i></div>`
            }} style={{ height: 20 }}></div>
            <div style={{ marginLeft: 10 }}>
               <span style={{ fontSize: '14px', color: '#000000' }}>
                  {message}
               </span>
            </div>
         </div>
      </div>
   )
}

export const randomString = (length = 40) => {
   const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
   let result = '';
   for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
   return result;
}

export const generateUUID = () => {
   function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
         .toString(16)
         .substring(1);
   }
   return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

export const getBlockId = (block) => {
   return block ? (block.id ? block.id : (block.temporary_id ? block.temporary_id : undefined)) : undefined
}

export const replaceNavigate = (url, value, key = ':id') => {
   return url.replace(key, value);
}

export const getTemporaryBlockId = (block) => {
   return block ? (block.id ? block.id : (block.temporary_block_id ? block.temporary_block_id : undefined)) : undefined
}

export const getButtonActionId = (block) => {
   return block ? (block.block_id ? block.block_id : (block.temporary_block_id ? block.temporary_block_id : undefined)) : undefined
}

export const processChangeCard = (data, card, faqId) => {
   if (getTemporaryBlockId(data.first_block) === faqId) {
      data.first_block.cards = data.first_block.cards.map((m) => {
         return getTemporaryBlockId(m) === getTemporaryBlockId(card) ? card : m
      });
   }
   data.blocks = data.blocks.map(m => {
      if (getTemporaryBlockId(m) === faqId) {
         m.cards = m.cards.map((m2) => getTemporaryBlockId(m2) === getTemporaryBlockId(card) ? card : m2)
      }
      return m;
   });
   return data
}

export const processDeleteCard = (data, card, faqId) => {
   if (getTemporaryBlockId(data.first_block) === faqId) {
      data.first_block.cards = data.first_block.cards.filter((m) => {
         return getTemporaryBlockId(m) !== getTemporaryBlockId(card)
      })
   }
   data.blocks = data.blocks.map(m => {
      if (getTemporaryBlockId(m) === faqId) {
         m.cards = m.cards.filter(m2 => {
            return getTemporaryBlockId(m2) !== getTemporaryBlockId(card)
         })
      }
      return m;
   });
   return data;
}

export const getPageById = (pages = [], id) => {
   return pages.find(f => f.social_id === id);
}

export const getEndOfDay = () => {
   let endOfDay = new Date();
   endOfDay.setHours(23, 59, 59, 999);
   return endOfDay;
}

export const minusDays = (time, day) => {
   let date = new Date(time);
   date.setDate(date.getDate() - day);
   return date;
}

export const copyText = (text) => {
   var tempTextArea = document.createElement("textarea");
   tempTextArea.value = text;
   document.body.appendChild(tempTextArea);
   tempTextArea.select();
   tempTextArea.setSelectionRange(0, 99999);

   document.execCommand("copy");

   document.body.removeChild(tempTextArea);
   showSuccessToasts("Sao chép thành công!");
}

export const toLocalISOString = (date) => {
   const pad = num => String(num).padStart(2, '0');
   const year = date.getFullYear();
   const month = pad(date.getMonth() + 1); // Months are zero-based
   const day = pad(date.getDate());
   const hours = pad(date.getHours());
   const minutes = pad(date.getMinutes());
   const seconds = pad(date.getSeconds());
   const milliseconds = String(date.getMilliseconds()).padStart(3, '0');

   return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
}

export const removeKeyEmptyInObj = (q) => {
   for (let key in q) {
      if (q[key] === null || q[key] === undefined || q[key] === '') {
         delete q[key];
      }
   }
   return q;
}

export const getColorByInitial = (initial) => {
   const colors = {
      A: '#FF5733',
      B: '#33FF57',
      C: '#3357FF',
      D: '#F1C40F',
      E: '#9B59B6',
      F: '#1ABC9C',
      G: '#E74C3C',
      H: '#34495E',
      I: '#F39C12',
      J: '#D35400',
      K: '#2ECC71',
      L: '#2980B9',
      M: '#8E44AD',
      N: '#27AE60',
      O: '#C0392B',
      P: '#16A085',
      Q: '#2C3E50',
      R: '#BDC3C7',
      S: '#7F8C8D',
      T: '#3498DB',
      U: '#1ABC9C',
      V: '#9B59B6',
      W: '#34495E',
      X: '#E74C3C',
      Y: '#F1C40F',
      Z: '#2ECC71',
   };

   const upperInitial = initial.toUpperCase();

   return colors[upperInitial] || '#000000';
}

export const getFirstLetterAndConvertToEnglish = (input) => {
   if (!input || typeof input !== 'string') {
      return '';
   }
   // Lấy chữ cái đầu tiên của chuỗi
   const firstChar = input.charAt(0);
   // Chuyển chữ cái đầu tiên về dạng chuẩn NFC và loại bỏ dấu
   const normalizedChar = firstChar.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
   return normalizedChar.toUpperCase();
}

export const setEndDay = (date) => {
   let endOfDay = new Date(date);
   endOfDay.setHours(23, 59, 59, 999);
   return endOfDay;
}

export const setBeginDay = (date) => {
   let endOfDay = new Date(date);
   endOfDay.setHours(0, 0, 0, 0);
   return endOfDay;
}

export const formatTimeChat = (inputDate) => {
   //khai báo thứ trong tuần
   const daysOfWeek = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
   const today = new Date();
   const date = new Date(inputDate);
   //tính toán giờ là buổi sáng hay buổi chiều
   const hours = date.getHours();
   const amPm = hours >= 12 ? 'CH' : 'SA';

   const timeString = formatTimeHM(date) + ' ' + amPm;
   const todayStart = new Date(today.setHours(0, 0, 0, 0));
   const dateStart = new Date(date.setHours(0, 0, 0, 0));
   // tính thời gian của 2 khoảng
   const differenceInTime = dateStart.getTime() - todayStart.getTime();
   const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));


   if (differenceInDays === 0) {
      return `${timeString}`;
   } else if (differenceInDays <= -1 && differenceInDays >= -6) {
      let dayOfWeek = daysOfWeek[date.getDay()];
      return `${dayOfWeek}, ${timeString}`;
   } else {
      const day = date.getDate()
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const yearNow = today.getFullYear();
      if (yearNow === year) {
         return `${addZeros(day)}/${addZeros(month)}`;
      }
      return `${addZeros(day)}/${addZeros(month)}/${addZeros(year)}`;
   }
}

export const timeDifferenceString = (timeSpecified) => {
   const currentTime = new Date();
   const difference = currentTime - timeSpecified;

   const msPerMinute = 60 * 1000;
   const msPerHour = msPerMinute * 60;
   const msPerDay = 24 * msPerHour;
   const msPerWeek = 7 * msPerDay;
   const msPerMonth = 30 * msPerDay; // Tạm tính một tháng là 30 ngày
   const msPerYear = 365 * msPerDay; // Tạm tính một năm là 365 ngày
   if (difference < msPerMinute) {
      return 'Vừa xong';
   } else if (difference < msPerHour) {
      const minutes = Math.floor(difference / msPerMinute);
      return `${minutes} phút trước`;
   } else if (difference < msPerDay) {
      const hours = Math.floor(difference / msPerHour);
      return `${hours} giờ trước`;
   } else if (difference < msPerWeek) {
      const days = Math.floor(difference / msPerDay);
      return `${days} ngày trước`;
   } else if (difference < msPerMonth) {
      const weeks = Math.floor(difference / msPerWeek);
      return `${weeks} tuần trước`;
   } else if (difference < msPerYear) {
      const months = Math.floor(difference / msPerMonth);
      return `${months} tháng trước`;
   } else {
      const years = Math.floor(difference / msPerYear);
      return `${years} năm trước`;
   }
}

export const formatCTAMsg = (cta) => {
   console.log('formatCTAMsg', cta);
   if (cta.type == 'web_url') {
      return {
         title: cta.url,
         type: cta.type,
         url: cta.title
      }
   }
   return cta;
}